// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"_b26b531","mobile":"_c7046d0","searchResult":"_d0f3fe3","resultList":"_264f6d5","article":"_266bc1f","active":"_8658390"};